import type { UnknownAction } from "redux";

import type { ColumnId, SortDirection } from "../../gql/graphql";

export type SortingActions = SortBookingsAction | ToggleSortBookingsAction;

export interface SortBookingsAction extends UnknownAction {
  payload: {
    direction: SortDirection;
    property: ColumnId;
  };
  type: "SORTING:SORT_BOOKINGS";
}

export const sortBookings = (
  property: ColumnId,
  direction: SortDirection,
): SortBookingsAction => ({
  payload: {
    direction,
    property,
  },
  type: "SORTING:SORT_BOOKINGS",
});

export interface ToggleSortBookingsAction extends UnknownAction {
  payload: {
    property: ColumnId;
  };
  type: "SORTING:TOGGLE_SORT_BOOKINGS";
}

export const toggleSortBookings = (
  property: ColumnId,
): ToggleSortBookingsAction => ({
  payload: {
    property,
  },
  type: "SORTING:TOGGLE_SORT_BOOKINGS",
});
